import { render, staticRenderFns } from "./StudentTimetable.vue?vue&type=template&id=7f96034a&scoped=true&lang=pug&"
import script from "./StudentTimetable.vue?vue&type=script&lang=ts&"
export * from "./StudentTimetable.vue?vue&type=script&lang=ts&"
import style0 from "./StudentTimetable.vue?vue&type=style&index=0&id=7f96034a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f96034a",
  null
  
)

export default component.exports